import styled from "styled-components";
import { palette, fonts, radii } from "../../styles/palette";

export const Page = styled.div`
  min-height: 100vh;
  background: ${palette.navy};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 560px;
  background: ${palette.white};
  border: 1px solid ${palette.border};
  border-radius: ${radii.lg};
  padding: 32px 28px;
  box-shadow: 0 18px 48px rgba(35, 35, 35, 0.24);
`;

export const Title = styled.h1`
  font-family: ${fonts.heading};
  font-size: 26px;
  font-weight: 700;
  color: ${palette.navy};
  margin: 0 0 8px 0;
  line-height: 1.2;
`;

export const Subtitle = styled.p`
  font-size: 15px;
  color: ${palette.textSecondary};
  line-height: 1.5;
  margin: 0 0 24px 0;
`;

export const SectionLabel = styled.p`
  font-size: 13px;
  font-weight: 700;
  color: ${palette.black};
  margin: 0 0 10px 0;
`;

/**
 * Los días van en fila y las horas en rejilla. Es a propósito: son dos
 * decisiones distintas y encadenadas (primero el día, luego la hora), y
 * mezclarlas en una sola lista de 72 opciones vuelve la elección un trabajo.
 */
export const DayRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  margin-bottom: 24px;
`;

export const DayButton = styled.button<{ $selected: boolean }>`
  flex: 1 0 auto;
  min-width: 96px;
  padding: 12px 10px;
  border-radius: ${radii.md};
  border: 2px solid ${({ $selected }) => ($selected ? palette.red : palette.border)};
  background: ${({ $selected }) => ($selected ? palette.red : palette.white)};
  color: ${({ $selected }) => ($selected ? palette.white : palette.black)};
  cursor: pointer;
  font-family: inherit;
  text-align: center;
  transition: border-color 0.15s, background 0.15s;

  &:hover:not(:disabled) {
    border-color: ${palette.red};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const DayName = styled.span`
  display: block;
  font-size: 12px;
  text-transform: capitalize;
  opacity: 0.85;
`;

export const DayNumber = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
`;

export const TimeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
  gap: 8px;
  max-height: 260px;
  overflow-y: auto;
`;

export const TimeButton = styled.button<{ $selected: boolean }>`
  padding: 11px 6px;
  border-radius: ${radii.sm};
  border: 2px solid ${({ $selected }) => ($selected ? palette.red : palette.border)};
  background: ${({ $selected }) => ($selected ? palette.red : palette.white)};
  color: ${({ $selected }) => ($selected ? palette.white : palette.black)};
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover:not(:disabled) {
    border-color: ${palette.red};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  width: 100%;
  margin-top: 24px;
  padding: 15px 24px;
  border: none;
  border-radius: ${radii.sm};
  background: ${palette.red};
  color: ${palette.white};
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: ${palette.redHover};
  }

  &:disabled {
    background: ${palette.gray};
    color: ${palette.textSecondary};
    cursor: not-allowed;
  }
`;

export const Notice = styled.div<{ $tone?: "error" | "info" }>`
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: ${radii.sm};
  font-size: 14px;
  line-height: 1.5;
  background: ${({ $tone }) => ($tone === "error" ? "#FDECEC" : palette.surfaceMuted)};
  color: ${({ $tone }) => ($tone === "error" ? palette.redHover : palette.textSecondary)};
  border: 1px solid ${({ $tone }) => ($tone === "error" ? palette.redLight : palette.border)};
`;

/** Resumen de lo agendado. El número que marcará va destacado a propósito. */
export const ConfirmedBox = styled.div`
  padding: 20px;
  border-radius: ${radii.md};
  background: ${palette.surfaceMuted};
  border: 1px solid ${palette.border};
  text-align: center;
`;

export const ConfirmedWhen = styled.p`
  font-family: ${fonts.heading};
  font-size: 20px;
  font-weight: 700;
  color: ${palette.navy};
  margin: 0 0 6px 0;
`;

export const CallerNumber = styled.strong`
  color: ${palette.red};
  white-space: nowrap;
`;

export const Timezone = styled.p`
  font-size: 12px;
  color: ${palette.textSecondary};
  margin: 16px 0 0 0;
  text-align: center;
`;
